const CustodyClearing = () => {
  return (
    <div id="CustodyClearing" className="custody-clearing container">
      <div className="content">
        <div className="section-header">
          <h2 className="section-title">Custody and Clearing</h2>
        </div>
        <div className="info">
          <p>Client assets are held at BNY Mellon Pershing, a qualified custodian. <a href="https://www.sipc.org/about-sipc/the-sipc-logo" target="_blank">SIPC</a> coverage applies up to applicable limits and does not protect against market losses. Custodial arrangements do not eliminate investment risk.</p>
          <a className="button" href="https://www.pershing.com/us/en/about/pershing-at-a-glance.html" target="_blank">Pershing at a Glance</a>
        </div>
        <div className="custody-disclaimers">
          <p>Please note that by clicking on this URL or hyperlink you will leave Borrelli Capital Management and enter another website created, operated and maintained by a different entity.</p>
          <p>Securities are offered through Insigneo Securities, LLC, member of FINRA and SIPC and advisory services are offered through Insigneo Advisory Services, LLC.</p>
        </div>
      </div>
    </div>
  );
}
 
export default CustodyClearing;
